import {
  FETCH_ORDER_REFUND_PENDING__ORDER_CANCELLATION,
  FETCH_ORDER_REFUND_REJECTED__ORDER_CANCELLATION,
  FETCH_ORDER_REFUND_FULFILLED__ORDER_CANCELLATION,
  SET_REFUNDED_ORDER_ITEMS__ORDER_CANCELLATION,
  FETCH_CANCELLATION_REASONS_PENDING__ORDER_CANCELLATION,
  FETCH_CANCELLATION_REASONS_FULFILLED__ORDER_CANCELLATION,
} from '../constants/orderCancellation';

const initialState = {
  pending: false,
  cancellationReasonsPending: true,
  order: {},
  orderItems: {},
  refundInvoiceNumber: null,
  error: {},
  cancellationReasons: [],
  success: false,
};

export const orderCancellation = (state = initialState, action) => {
  switch (action.type) {
    case SET_REFUNDED_ORDER_ITEMS__ORDER_CANCELLATION:
      return {
        ...state,
        orderItems: action.response.orderItems,
        order: action.response.order,
        refundInvoiceNumber: action.response.refundInvoiceNumber,
        error: {},
        success: false,
      };

    case FETCH_ORDER_REFUND_PENDING__ORDER_CANCELLATION:
      return { ...state, pending: true, error: [] };

    case FETCH_CANCELLATION_REASONS_PENDING__ORDER_CANCELLATION:
      return { ...state, cancellationReasonsPending: true };

    case FETCH_CANCELLATION_REASONS_FULFILLED__ORDER_CANCELLATION:
      return {
        ...state,
        cancellationReasonsPending: false,
        cancellationReasons: action.response.results,
      };

    case FETCH_ORDER_REFUND_REJECTED__ORDER_CANCELLATION:
      return { ...state, pending: false, error: action.error.response.data };

    case FETCH_ORDER_REFUND_FULFILLED__ORDER_CANCELLATION:
      return {
        ...state,
        order: action.response,
        pending: false,
        success: true,
        error: [],
      };

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/orderCancellation.js